// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"348":"a75abad2","847":"2ba155bd","966":"c719502b"}[chunkId] + ".chunk.css";
};